// Use service layer instead of direct Firestore access
import { UserRole } from '../types/enums';
import { updateThreadParticipants as updateThreadParticipantsService, createThread as createThreadService, addSystemMessage as addSystemMessageService } from '../services/messagingService';

export const updateThreadParticipants = async (threadId, newParticipant) => {
  try {
    // Use the service layer instead of direct Firestore access
    const result = await updateThreadParticipantsService(threadId, newParticipant);
    console.log('Successfully updated thread participants:', { threadId, newParticipant });
    return result;
  } catch (error) {
    console.error('Error updating thread participants:', error);
    throw error;
  }
};

export const createThread = async (participants, subject) => {
  try {
    // Validate participant data
    if (!participants || !Array.isArray(participants) || participants.length === 0) {
      throw new Error('Invalid participants data');
    }

    // Format participants data, ensuring all required fields are present
    const formattedParticipants = participants.map(p => {
      if (!p.id) throw new Error('Participant missing ID');
      if (!p.role) throw new Error('Participant missing role');
      
      // Ensure role is properly formatted - handle both single role and array of roles
      const validRoles = [UserRole.ADMIN, UserRole.DOCTOR, UserRole.NURSE, UserRole.FACILITY_ADMIN];
      const userRoles = p.role || [];
      const roles = Array.isArray(userRoles) ? userRoles : [userRoles];
      const roleStrings = roles.map(role => String(role).toLowerCase());
      
      // Check if any of the user's roles are valid
      const hasValidRole = validRoles.some(validRole => 
        roleStrings.includes(validRole.toLowerCase())
      );
      
      if (!hasValidRole) {
        throw new Error(`Invalid role: ${p.role}. Must be one of: ${validRoles.join(', ')}`);
      }
      
      // Use the first valid role for the participant
      const role = roleStrings.find(r => validRoles.map(vr => vr.toLowerCase()).includes(r)) || roleStrings[0];
      
      return {
        id: p.id,
        name: p.firstName && p.lastName ? `${p.firstName} ${p.lastName}` : p.email,
        role: role
      };
    });

    // Use the service layer instead of direct Firestore access
    const threadRef = await createThreadService(formattedParticipants, subject);
    
    // Add initial system message
    await addSystemMessage(threadRef.id, 'Thread created');

    return threadRef;
  } catch (error) {
    console.error('Error creating thread:', error);
    throw error;
  }
};

export const addSystemMessage = async (threadId, content) => {
  try {
    // Use the service layer instead of direct Firestore access
    const result = await addSystemMessageService(threadId, content);
    console.log('Successfully added system message:', { threadId, content });
    return result;
  } catch (error) {
    console.error('Error adding system message:', error);
    throw error;
  }
};